import * as i0 from '@angular/core';
import * as i1 from './table.module';
import * as i2 from '@angular/common';
import * as i3 from '../checkbox/checkbox.component';
import * as i4 from '../toggle/toggle.component';
import * as i5 from '../radio/radio.component';
import * as i6 from '../radio/radio-group.component';
import * as i7 from '../input/label.component';
import * as i8 from '../input/input.directive';
import * as i9 from '../input/text-area.directive';
import * as i10 from '../button/button.directive';
import * as i11 from '@angular/forms';
import * as i12 from '../icon/icon.component';
import * as i13 from '../icon/sprite.component';
import * as i14 from '../dialog/dialog.component';
import * as i15 from '../dialog/tooltip/tooltip.component';
import * as i16 from '../dialog/overflow-menu/overflow-menu.component';
import * as i17 from '../dialog/overflow-menu/overflow-menu-pane.component';
import * as i18 from '../dialog/dialog.directive';
import * as i19 from '../dialog/tooltip/tooltip.directive';
import * as i20 from '../dialog/tooltip/ellipsis-tooltip.directive';
import * as i21 from '../dialog/overflow-menu/overflow-menu.directive';
import * as i22 from '../dialog/overflow-menu/overflow-menu-option.component';
import * as i23 from '../dialog/dialog-placeholder.component';
import * as i24 from '../icon/static-icon.component';
import * as i25 from './table.component';
import * as i26 from '../forms/forms.module';
import * as i27 from '../icon/icon.module';
import * as i28 from '../dialog/dialog.module';
import * as i29 from '../icon/static-icon.module';
import * as i30 from '../i18n/i18n.module';
export const TableModuleNgFactory:i0.NgModuleFactory<i1.TableModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.Checkbox = (<any>(null as any));
var _decl0_12:i4.Toggle = (<any>(null as any));
var _decl0_13:i5.Radio = (<any>(null as any));
var _decl0_14:i6.RadioGroup = (<any>(null as any));
var _decl0_15:i7.Label = (<any>(null as any));
var _decl0_16:i8.TextInput = (<any>(null as any));
var _decl0_17:i9.TextArea = (<any>(null as any));
var _decl0_18:i10.Button = (<any>(null as any));
var _decl0_19:i11.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_20:i11.NgSelectOption = (<any>(null as any));
var _decl0_21:i11.ɵangular_packages_forms_forms_r = (<any>(null as any));
var _decl0_22:i11.DefaultValueAccessor = (<any>(null as any));
var _decl0_23:i11.ɵangular_packages_forms_forms_bd = (<any>(null as any));
var _decl0_24:i11.ɵangular_packages_forms_forms_bf = (<any>(null as any));
var _decl0_25:i11.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_26:i11.SelectControlValueAccessor = (<any>(null as any));
var _decl0_27:i11.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_28:i11.RadioControlValueAccessor = (<any>(null as any));
var _decl0_29:i11.NgControlStatus = (<any>(null as any));
var _decl0_30:i11.NgControlStatusGroup = (<any>(null as any));
var _decl0_31:i11.RequiredValidator = (<any>(null as any));
var _decl0_32:i11.MinLengthValidator = (<any>(null as any));
var _decl0_33:i11.MaxLengthValidator = (<any>(null as any));
var _decl0_34:i11.PatternValidator = (<any>(null as any));
var _decl0_35:i11.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_36:i11.EmailValidator = (<any>(null as any));
var _decl0_37:i11.NgModel = (<any>(null as any));
var _decl0_38:i11.NgModelGroup = (<any>(null as any));
var _decl0_39:i11.NgForm = (<any>(null as any));
var _decl0_40:i12.Icon = (<any>(null as any));
var _decl0_41:i13.Sprite = (<any>(null as any));
var _decl0_42:i14.Dialog = (<any>(null as any));
var _decl0_43:i15.Tooltip = (<any>(null as any));
var _decl0_44:i16.OverflowMenu = (<any>(null as any));
var _decl0_45:i17.OverflowMenuPane = (<any>(null as any));
var _decl0_46:i18.DialogDirective = (<any>(null as any));
var _decl0_47:i19.TooltipDirective = (<any>(null as any));
var _decl0_48:i20.EllipsisTooltip = (<any>(null as any));
var _decl0_49:i21.OverflowMenuDirective = (<any>(null as any));
var _decl0_50:i22.OverflowMenuOption = (<any>(null as any));
var _decl0_51:i23.DialogPlaceholder = (<any>(null as any));
var _decl0_52:i24.StaticIcon = (<any>(null as any));
var _decl0_53:i25.Table = (<any>(null as any));
var _decl0_54:i2.AsyncPipe = (<any>(null as any));
var _decl0_55:i2.UpperCasePipe = (<any>(null as any));
var _decl0_56:i2.LowerCasePipe = (<any>(null as any));
var _decl0_57:i2.JsonPipe = (<any>(null as any));
var _decl0_58:i2.SlicePipe = (<any>(null as any));
var _decl0_59:i2.DecimalPipe = (<any>(null as any));
var _decl0_60:i2.PercentPipe = (<any>(null as any));
var _decl0_61:i2.TitleCasePipe = (<any>(null as any));
var _decl0_62:i2.CurrencyPipe = (<any>(null as any));
var _decl0_63:i2.DatePipe = (<any>(null as any));
var _decl0_64:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_65:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_66:i2.KeyValuePipe = (<any>(null as any));
var _decl0_67:i2.CommonModule = (<any>(null as any));
var _decl0_68:i26.NFormsModule = (<any>(null as any));
var _decl0_69:i11.FormsModule = (<any>(null as any));
var _decl0_70:i27.IconModule = (<any>(null as any));
var _decl0_71:i28.DialogModule = (<any>(null as any));
var _decl0_72:i29.StaticIconModule = (<any>(null as any));
var _decl0_73:i30.I18nModule = (<any>(null as any));
var _decl0_74:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_75:i0.ElementRef<any> = (<any>(null as any));
function _View_Table_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_Table_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'bx--data-table-v2';
  currVal_0;
  const currVal_1:any = (<any>{'bx--data-table-v2--compact':(_decl0_53.size === 'sm'),
      'bx--data-table-v2--tall':(_decl0_53.size === 'lg'),'bx--data-table-v2--zebra':_decl0_53.striped});
  currVal_1;
  const currVal_2:any = _decl0_53.model.hasExpandableRows();
  currVal_2;
  const currVal_3:any = _decl0_53.showSelectionColumn;
  currVal_3;
  const currVal_4:any = _decl0_53.model.header;
  currVal_4;
  const currVal_5:any = (<any>{'width':(_decl0_53.scrollbarWidth + 'px'),'padding':0,
      'border':0});
  currVal_5;
  const currVal_6:any = !_decl0_53.noData;
  currVal_6;
  const currVal_7:any = _any;
  currVal_7;
  const currVal_8:any = _decl0_53.model.isLoading;
  currVal_8;
  const currVal_9:any = _decl0_53.model.isEnd;
  currVal_9;
}
